class Passcode {
  passcode: string;

  constructor(passcode: string) {
    this.passcode = passcode;
  }
}

export default Passcode;
